import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

export const ConfirmDialog = props => {
  const { title, children, open, setOpen, onConfirm } = props;

  return (
    <Dialog
      sx={{ zIndex: 9999999 }}
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="confirm-dialog"
    >
      <DialogTitle id="confirm-dialog">{title}</DialogTitle>
      <DialogContent p={3}>{children}</DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          onClick={() => setOpen(false)}
          color="secondary"
        >
          Nie
        </Button>
        <Button
          color="primary"
          variant="contained"
          onClick={() => {
            setOpen(false);
            onConfirm();
          }}
        >
          Tak
        </Button>
      </DialogActions>
    </Dialog>
  );
};
